import React from 'react';
import { pureRender } from 'epic-alt-utils';
import autobind from 'core-decorators/lib/autobind';
import { NavActions } from '../../actions';
import { getDataAttribute } from '../../utils/compatibilityUtils';
import each from 'lodash/each';
import { downloads } from '../../constants';
import './epicGamesToggle.sass';
import browser from 'bowser';

@pureRender
export default class EpicGamesToggle extends React.Component {
    constructor(props) {
        super(props);
        this.listenerOn = false;
        this.state = {
            hoverTriangle: false
        };
    }

    addListener() {
        //Add a click listener anywhere on the page which will close the dropdown
        document.body.addEventListener('click', this.closeEgNav);
        this.listenerOn = true;
    }

    removeListener() {
        //remove the click listener
        document.body.removeEventListener('click', this.closeEgNav);
        this.listenerOn = false;
    }

    componentDidUpdate() {
        if (this.props.isActive && !this.listenerOn && !this.context.isDesktop) {
            this.addListener();
        }
    }

    componentWillUnmount() {
        this.removeListener();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isActive && !nextProps.isActive && this.listenerOn) {
            this.closeEgNav();
        }
    }

    @autobind
    closeEgNav(event) {
        this.removeListener();
        setTimeout(() => {
            NavActions.egNavActive(false);
        }, 100);
    }

    @autobind
    showProperties(event) {
        const setActive = () => {
            NavActions.egNavActive({ isActive: true, isMobile: this.context.isMobile });
            //Reset all other clickable items
            NavActions.searchActive(false);
            NavActions.tabletNavActive(false);
            NavActions.mobileNavActive(false);
            NavActions.mobileNavActiveLinks(false);
        };

        const toggle = () => {
            if (!this.props.isActive) {
                setActive();
            } else {
                this.closeEgNav(event);
            }
        };

        if (event) {
            if (this.context.isDesktop && event.type === 'mouseenter') {
                setActive();
            } else if (this.context.isDesktop && event.type === 'mouseleave') {
                NavActions.egNavActive(false);
            } else if (!this.context.isDesktop && event.type === 'click' || this.context.isDesktop && event.type === 'touchend') {
                window.scrollTo(0, 0);
                toggle();
            }
        } else {
            toggle();
        }
    }

    @autobind
    downloadClick(e) {
        const dl = this.props.downloadLink;
        if (dl && dl.onClick && typeof dl.onClick === 'function') {
            dl.onClick(e);
        }
    }

    @autobind
    linkClick(e) {
        if (getDataAttribute(e.currentTarget, 'disabled')) {
            e.preventDefault();
        }
    }

    @autobind
    mouseLeaveTriangle() {
        this.setState({
            hoverTriangle: false
        });
    }

    @autobind
    mouseEnterTriangle() {
        this.setState({
            hoverTriangle: true
        });
    }

    getDownloadUrl() {
        if (browser.mac) {
            return this.props.macDownloadUrl || downloads.macDownloadUrl;
        }
        return this.props.pcDownloadUrl || downloads.pcDownloadUrl;
    }

    render() {
        let btnClass = 'egLogo cursor-pointer';
        let active = false;
        if (this.props.isActive) {
            active = true;
            btnClass += ' active';
        }

        //properties refers to the epic games properties to be listed under the epic shield
        const properties = this.props.properties || {};

        const href = this.getDownloadUrl();
        let title = this.context.messages.default_download;
        const dl = this.props.downloadLink;
        if (dl) {
            if (dl.title) {
                title = dl.title;
            }
        }

        const array = [];

        each(properties, (property) => {
            if (property.egName) {
                const current = this.props.epicPropertyName === property.propertyKey;
                array.push(
                    <li key={property.propertyKey} className={current ? 'active text-color-active' : ''}>
                        <a
                            href={property.egHref || '#'}
                            data-disabled={current}
                            className={current ? 'text-color-active' : 'text-color-hover text-color-dark-nonactive'}>{property.egName}</a>
                    </li>
                );
            }
        });

        return (
            <div
                id="egLogo"
                className={btnClass}
                onMouseEnter={this.showProperties}
                onMouseLeave={this.showProperties}
                onClick={this.showProperties}
                onTouchEnd={this.showProperties}>
                <div className={`shieldLogo text-color bg-color text-color-border-after ${this.state.hoverTriangle ? 'mouse-over' : ''}`}/>
                <div className="shield-triangle-hover-fix" onMouseLeave={this.mouseLeaveTriangle} onMouseEnter={this.mouseEnterTriangle}/>
                {!this.context.isDesktop ? <div className={`mobile-overlay ${active ? 'active' : ''}`}></div> : ''}
                <div id="eg-properties" className="bg-color">
                    <ul>
                        {array}
                    </ul>
                    <ul className="download-link accent-bg-color accent-bg-color-hover">
                        <li onClick={this.downloadClick}>
                            <a id="downloadLink" className="accent-text-color" href={href}>{title}</a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

EpicGamesToggle.propTypes = {
    isActive: React.PropTypes.bool,
    epicPropertyName: React.PropTypes.string,
    epicPropertyConfig: React.PropTypes.object,
    downloadLink: React.PropTypes.object,
    properties: React.PropTypes.array,
    pcDownloadUrl: React.PropTypes.string,
    macDownloadUrl: React.PropTypes.string
};


EpicGamesToggle.contextTypes = {
    isMobile: React.PropTypes.bool,
    isTablet: React.PropTypes.bool,
    isDesktop: React.PropTypes.bool,
    messages: React.PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/epicGamesToggle/EpicGamesToggle.js
 **/